module.exports = __webpack_public_path__ + "img/30.b7742484.png";